import { get } from 'svelte/store';
import { api } from '../../../../helpers';
import { changeToken } from '../../../../Api';
import { wikiCategoryId } from '../store';
import { activeTags, flowId, globalSearch, isShowSearchLoader, list, ordering, pagination, tags } from '../../../stores';
import { location } from 'svelte-spa-router';
import { tick } from 'svelte';
import { scrolledPublicationId } from '../../Newsline/store';
import { getTags, searchPublications } from "../../../custom/GlobalSearch/services/index.js";
export const getWikiList = async (page = 1) => {
    const searchByText = get(globalSearch);
    if (searchByText) {
        const match = get(location).match(/\d+/);
        const wikiPage = match ? parseInt(match[0], 10) : null;
        await searchPublications({ page, orderingGroup: 'wiki', feedGroup: '', wikiPage });
        return;
    }
    const tags = get(activeTags);
    const idFlow = get(flowId);
    const sort = get(ordering);
    let path = `/api/v1/publication/wiki/list/${get(wikiCategoryId)}/?page=${page}`;
    for (let tag of tags) {
        if (tags.length) {
            path += `&feed_tags=${tag}`;
        }
    }
    if (idFlow) {
        path += `&flows=${idFlow}`;
    }
    if (sort) {
        path += `&ordering=${sort}`;
    }
    const response = await api(path);
    if (!response.ok) {
        changeToken(response.status);
        return;
    }
    const data = await response.json();
    list.update((n) => [...n, ...data.results]);
    pagination.set(data.pagination);
};
async function filterNewsByFlow({ id }) {
    list.set([]);
    isShowSearchLoader.set(true);
    flowId.set(id);
    await getWikiList();
    isShowSearchLoader.set(false);
}
;
const filterNewsByOrdering = async ({ value }) => {
    list.set([]);
    isShowSearchLoader.set(true);
    ordering.set(value);
    await getWikiList();
    isShowSearchLoader.set(false);
};
export const changeNews = async (e) => {
    const type = e.detail.type;
    const option = e.detail.option;
    if (type === 'ordering') {
        filterNewsByOrdering(option);
    }
    if (type === 'flow') {
        filterNewsByFlow(option);
    }
};
export const infiniteScrollHandler = async () => {
    isShowSearchLoader.set(true);
    await getWikiList(get(pagination).next_page_number);
    isShowSearchLoader.set(false);
};
export const initWikiPublications = async () => {
    // resetSearch()
    // const searchParams = new URLSearchParams(get(querystring))
    // const search = searchParams.get('search')
    wikiCategoryId.set(+get(location).replace(/[^0-9]/g, ''));
    // globalSearch.set(search || '')
    list.set([]);
    await getWikiList();
    if (!get(tags).length) {
        await getTags();
    }
    isShowSearchLoader.set(false);
    await tick();
    const publication = document.getElementById(get(scrolledPublicationId));
    if (publication) {
        publication.scrollIntoView({ block: 'center' });
    }
};
